module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-2-4-e0e53f30f5a53f868f5dec50efa273a0.png";